export const namespace = 'auth'
